
// 状态值的改变方法,操作状态值
// 提交mutations是更改Vuex状态的唯一方法

export const changeResturantId = (state, resturantId) => { // 更新店铺ID
  state.resturantId = resturantId
}
export const changeResturantName = (state, resturantName) => { // 更新店铺名称
  state.resturantName = resturantName
}
export const updataStatisticalDate = state => { // 更新数据统计日期

}
export const resetStore = state => { // 重置store
  state.resturantName = '全部门店'
  state.resturantId = 0
}



// WEBPACK FOOTER //
// ./src/store/mutations.js